const o = 5;
function s(l) {
  if (!(l != null && l.links.length) || !(l != null && l.title)) return null;
  const i = Math.ceil(l.links.length / 5),
    e = i > 5 ? i : 5,
    n = [];
  for (let t = 0; t < l.links.length; t += e) n.push(l.links.slice(t, t + e));
  return {
    title: l.title,
    links: n
  };
}
export { s as groupTabLinks };